// extracted by mini-css-extract-plugin
module.exports = {"input":"TextArea_input__sE6Y9"};